import React from 'react';
import { useNavigate } from 'react-router-dom';
import './breadcrumbs.css';

interface BreadcrumbsProps {
  to?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ to }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(to ?? '/');
  };

  return (
    <div className="d-flex justify-content-start space col-6">
      <button
        className="BtnTop yellowTxt btn text-decoration-none backBtn"
        onClick={handleBack}
      >
        Back
      </button>
    </div>
  );
};

export default Breadcrumbs;
